function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "29",
  height: "16",
  viewBox: "0 0 29 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 0C8.67 0 3.46 3.11 0 8c3.46 4.89 8.67 8 14.5 8S25.54 12.89 29 8c-3.46-4.89-8.67-8-14.5-8zm0 12.5A4.49 4.49 0 0110.03 8c0-2.48 2-4.5 4.47-4.5A4.49 4.49 0 0118.97 8c0 2.48-2 4.5-4.47 4.5z",
  fill: "#2D455D"
})));